export default __webpack_public_path__ + "static/cross-80126af71936d2b73d20d162db809ee2.png";